__turbopack_context__.v({
  "buttonRow": "SignUpForm-module-scss-module__h0dMQG__buttonRow",
  "checkboxInput": "SignUpForm-module-scss-module__h0dMQG__checkboxInput",
  "checkboxRow": "SignUpForm-module-scss-module__h0dMQG__checkboxRow",
  "checkboxText": "SignUpForm-module-scss-module__h0dMQG__checkboxText",
  "formColumn": "SignUpForm-module-scss-module__h0dMQG__formColumn",
  "formRow": "SignUpForm-module-scss-module__h0dMQG__formRow",
  "htmlText": "SignUpForm-module-scss-module__h0dMQG__htmlText",
  "isDisabled": "SignUpForm-module-scss-module__h0dMQG__isDisabled",
  "loginButton": "SignUpForm-module-scss-module__h0dMQG__loginButton",
  "loginErrorMessage": "SignUpForm-module-scss-module__h0dMQG__loginErrorMessage",
  "radioBttnRow": "SignUpForm-module-scss-module__h0dMQG__radioBttnRow",
  "radioText": "SignUpForm-module-scss-module__h0dMQG__radioText",
  "signupContainer": "SignUpForm-module-scss-module__h0dMQG__signupContainer",
});
